// eslint-disable-next-line import/prefer-default-export
export enum ConnectorNames {
  Injected = 'injected',
  MetaMask = 'metaMask'
}
